// extracted by mini-css-extract-plugin
module.exports = {"customNav":"Navbar-module--customNav--ViBQ9","text":"Navbar-module--text--AegQv"};